import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import { getHolidays, getHolidayQueryObject } from "@/helpers/holidaysHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  async getFeatureGroupsForEvents(
    { commit, state },
    { getAll, additionalPrincipals } = {}
  ) {
    const headers = getTokenHeader();
    const principals = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals.forEach(principal => {
        principals.push(principal.id);
      });
    if (additionalPrincipals?.length) principals.push(...additionalPrincipals);
    const params = { principal_id: { $in: principals } };
    if (getAll) {
      params.all = true;
    }
    if (headers)
      try {
        const response = await axios.get(
          `${env.events_api_client_url}feature_group/`,
          {
            headers,
            params
          }
        );
        commit("SET_FEATURE_GROUPS_FOR_EVENTS", response?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async getCategoryGroupsForEvents(
    { commit, state },
    { additionalPrincipals, ignorePrincipal } = {}
  ) {
    const headers = getTokenHeader();
    const principals = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal?.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals?.forEach(principal => {
        principals.push(principal.id);
      });
    if (additionalPrincipals?.length) principals.push(...additionalPrincipals);
    let params;

    params = {
      mainPrincipal: state.selectedPrincipal.id,
      principal_id: { $in: principals }
    };
    if (ignorePrincipal) params.ignorePrincipal = true;
    if (headers) {
      const response = await axios.get(
        `${env.events_api_client_url}category_group/`,
        {
          params,
          headers
        }
      );
      const categoryGroups = response?.data ?? [];
      commit("SET_CATEGORY_GROUPS_FOR_EVENTS", categoryGroups);
    }
  },
  async getEventsAppContentTypes({ commit }, params) {
    const headers = getTokenHeader();
    const response = await axios.get(
      `${env.events_api_client_url}app_content_type`,
      {
        headers,
        params
      }
    );
    commit("SET_EVENTS_APP_CONTENT_TYPES", response.data);
  },
  async getEventStatistics({ commit, state }, filter = {}) {
    const headers = getTokenHeader();
    let principals = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal?.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals.forEach(principal => {
        principals.push(principal.id);
      });
    if (headers) {
      const response = await axios.get(
        `${env.events_api_client_url}event/statistics`,
        {
          params: {
            ...filter,
            principal_id: { $in: principals }
          },
          headers
        }
      );
      const eventStatistics = response?.data ?? {};
      commit("SET_EVENT_STATISTICS", eventStatistics);
    }
  },
  async getEvents({ commit, state }, filter = {}) {
    if (filter.isDefault) return;
    const headers = getTokenHeader();
    let principals = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal?.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals.forEach(principal => {
        principals.push(principal.id);
      });
    if (filter?.subPrincipals?.length) principals = filter?.subPrincipals;
    filter.principal_id = { $in: principals };
    filter.backendSearch = true;
    if (headers) {
      const {
        data
      } = await axios.post(
        `${env.events_api_client_url}event/for_calendar`,
        filter,
        { headers }
      );
      const allIds = data?.allIds;
      const events = data?.results ?? [];
      const count = data?.totalCount ?? 0;
      events.forEach(event => {
        event.groupStart = moment(
          event?.moment?.from ?? event?.start,
          null,
          "de"
        ).format("dddd, DD.MM.YYYY");
      });
      commit("SET_ALLEVENTS_IDS", allIds);
      commit("SET_EVENTS", events);
      commit("SET_EVENT_COUNT", count);
    }
  },
  async getExternEvents({ commit, state }, filter = {}) {
    if (filter.isDefault) return;
    const headers = getTokenHeader();
    let principals = [state.selectedPrincipal.id];

    filter.principal_id = { $in: principals };
    filter.backendSearch = true;
    if (headers) {
      const {
        data
      } = await axios.post(
        `${env.events_api_client_url}externEvents/for_calendar`,
        filter,
        { headers }
      );
      const allIds = data?.allIds;
      const events = data?.results ?? [];
      const count = data?.totalCount ?? 0;
      events.forEach(event => {
        event.groupStart = moment(
          event?.moment?.from ?? event?.start,
          null,
          "de"
        ).format("dddd, DD.MM.YYYY");
      });
      commit("SET_ALL_EXTERN_EVENTS_IDS", allIds);
      commit("SET_EXTERN_EVENTS", events);
      commit("SET_EXTERN_EVENT_COUNT", count);
    }
  },
  async getDuplicates({ commit, state }, payload = {}) {
    const headers = getTokenHeader();
    const principalIds = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal?.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals?.forEach(principal => {
        principalIds.push(principal.id);
      });
    if (payload.additionalPrincipals?.length)
      principalIds.push(...payload.additionalPrincipals);
    const filter = {
      principalIds
    };
    if (headers) {
      const res = await axios.get(
        `${env.events_api_client_url}event/duplicates`,
        {
          params: {
            ...filter
          },
          headers
        }
      );
      commit("SET_EVENT_DUPLICATES", res.data);
    }
  },
  async getOrganizer({ commit, state }, payload) {
    const eventList = payload.eventList;
    let filter = { ...(payload.filter || {}) };

    const headers = getTokenHeader();
    let principals = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal?.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals.forEach(principal => {
        principals.push(principal.id);
      });
    if (filter?.subPrincipals?.length) principals = filter?.subPrincipals;
    if (headers) {
      const parsedLimit = Number(filter.limit);
      filter.limit =
        Number.isFinite(parsedLimit) && parsedLimit > 0
          ? parsedLimit
          : eventList
          ? 1500
          : 10;

      const parsedPage = Number(filter.page);
      filter.page =
        Number.isFinite(parsedPage) && parsedPage > 0 ? parsedPage : 1;

      let organizer = [];
      if (!eventList) {
        const response = await axios.get(`${env.events_api_client_url}oploc`, {
          params: {
            ...filter,
            principal_id: principals
          },
          headers
        });
        organizer = response?.data ?? [];
        let count = Number(response?.headers?.["x-count"] ?? organizer?.length);
        if (isNaN(count)) count = 0;
        commit("SET_ORGANIZER", { organizer, count });
        return;
      }

      let maxPages = 1;
      for (let i = 1; i <= maxPages; i++) {
        const response = await axios.get(`${env.events_api_client_url}oploc`, {
          params: {
            ...filter,
            page: i,
            principal_id: principals
          },
          headers
        });
        organizer = organizer.concat(response?.data);
        let count = Number(
          response?.headers?.["x-count"] ?? organizer?.length ?? 0
        );
        if (i === 1) maxPages = Math.ceil((count || 1) / filter.limit);

        if (isNaN(count)) count = 0;
        commit("SET_ORGANIZER", { organizer, count });
      }
    }
  },
  async getOrganizerCities({ commit, state }) {
    const headers = getTokenHeader();
    let principals = [state.selectedPrincipal.id];
    const subPrincipals = state.selectedPrincipal?.subPrincipals;
    if (subPrincipals?.length)
      subPrincipals.forEach(principal => {
        principals.push(principal.id);
      });
    if (headers) {
      const response = await axios.get(`${env.events_api_client_url}oploc`, {
        params: {
          principal_id: principals
        },
        headers
      });
      const organizer = response?.data ?? [];
      const cities = _.uniq(
        organizer.map(organizer => organizer?.address?.city)
      );
      commit("SET_ORGANIZER_CITIES", cities);
    }
  },
  async getEventsApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(
          `${env.events_api_client_url}apiKey/`,
          {
            params: {
              ...query,
              principal: state.selectedPrincipal.id
            },
            headers
          }
        );
        commit("SET_EVENTS_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getEventsConfig({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(`${env.events_api_client_url}config`, {
        params: {
          ...query,
          principal_id: state.selectedPrincipal.id
        },
        headers
      });
      const organizer = response?.data ?? {};
      commit("SET_EVENTS_CONFIG", organizer);
    }
  },
  async getMomentsForEvent({ commit }, id) {
    const headers = getTokenHeader();
    const response = await axios.get(
      `${env.events_api_client_url}moment/for_event/${id}`,
      {
        headers
      }
    );
    commit("SET_MOMENTS_FOR_EVENT", response?.data ?? []);
  },
  async deleteMoment({ state }, { momentId, eventId }) {
    try {
      const headers = getTokenHeader();
      const response = await axios.delete(
        `${env.events_api_client_url}moment/${momentId}`,
        {
          headers,
          params: {
            principal_id: state.selectedPrincipal.id
          }
        }
      );
      if (response.status === 200) {
        await this.dispatch("getMomentsForEvent", eventId);
        await this.dispatch("createSuccess", "Erfolgreich gelöscht!");
      } else await this.dispatch("createError", response);
    } catch (error) {
      await this.dispatch("createError", error);
    }
  },
  async updateMoment({ state }, { moment, eventId }) {
    try {
      const headers = getTokenHeader();
      const response = await axios.put(
        `${env.events_api_client_url}moment/`,
        { ...moment, event_id: eventId },
        {
          headers,
          params: {
            principal_id: state.selectedPrincipal.id
          }
        }
      );
      if (response.status === 200) {
        await this.dispatch("getMomentsForEvent", eventId);
        await this.dispatch("createSuccess", "Erfolgreich aktualisiert!");
        return true;
      } else await this.dispatch("createError", response);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async createMoment({ state }, { moment, eventId }) {
    try {
      const headers = getTokenHeader();
      const response = await axios.post(
        `${env.events_api_client_url}moment/`,
        { ...moment, event_id: eventId },
        {
          headers,
          params: {
            principal_id: state.selectedPrincipal.id
          }
        }
      );
      if (response.status === 200) {
        await this.dispatch("getMomentsForEvent", eventId);
        await this.dispatch("createSuccess", "Erfolgreich erstellt!");
        return true;
      } else await this.dispatch("createError", response);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getHolidays({ commit }, { state, year }) {
    const query = getHolidayQueryObject(year, state, "PublicHolidays");
    commit("SET_HOLIDAYS", (await getHolidays(query)) ?? []);
  },
  async getVacations({ commit }, { state, year }) {
    const query = getHolidayQueryObject(year, state, "SchoolHolidays");
    commit("SET_VACATIONS", (await getHolidays(query)) ?? []);
  }
};
